import React from "react";

export default function VisibleIcon({ fill }) {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   version="1.1"
    //   width="15px"
    //   height="15px"
    //   viewBox="0 0 50 50"
    // >
    //   <g>
    //     <path
    //       fill="#2da2f8"
    //       d="M 47.5,23.5 C 47.5,25.1667 47.5,26.8333 47.5,28.5C 46.1779,28.67 45.0113,28.3366 44,27.5C 37.4862,13.4982 26.9862,9.33152 12.5,15C 8.21627,18.2881 5.04961,22.4547 3,27.5C 1.98873,28.3366 0.822066,28.67 -0.5,28.5C -0.5,26.8333 -0.5,25.1667 -0.5,23.5C 8.51982,8.33067 21.1865,4.49733 37.5,12C 41.8938,14.9835 45.2271,18.8168 47.5,23.5 Z"
    //     />
    //   </g>
    //   <g>
    //     <path
    //       fill="#2ca0f8"
    //       d="M 18.5,16.5 C 32.2512,15.7425 36.2512,21.5758 30.5,34C 23.3214,38.2824 17.8214,36.7824 14,29.5C 12.6751,24.1569 14.1751,19.8236 18.5,16.5 Z"
    //     />
    //   </g>
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={19}
      viewBox="0 0 576 512"
    >
      <path
        fill={fill}
        d="M160 256C160 185.3 217.3 128 288 128C358.7 128 416 185.3 416 256C416 326.7 358.7 384 288 384C217.3 384 160 326.7 160 256zM288 336C332.2 336 368 300.2 368 256C368 211.8 332.2 176 288 176C287.3 176 286.7 176 285.1 176C287.3 181.1 288 186.5 288 192C288 227.3 259.3 256 224 256C218.5 256 213.1 255.3 208 253.1C208 254.7 208 255.3 208 255.1C208 300.2 243.8 336 288 336L288 336zM95.42 112.6C142.5 68.84 207.2 32 288 32C368.8 32 433.5 68.84 480.6 112.6C527.4 156 558.7 207.1 573.5 243.7C576.8 251.6 576.8 260.4 573.5 268.3C558.7 304 527.4 355.1 480.6 399.4C433.5 443.2 368.8 480 288 480C207.2 480 142.5 443.2 95.42 399.4C48.62 355.1 17.34 304 2.461 268.3C-.8205 260.4-.8205 251.6 2.461 243.7C17.34 207.1 48.62 156 95.42 112.6V112.6zM288 80C222.8 80 169.2 109.6 128.1 147.7C89.6 183.5 63.02 225.1 49.44 256C63.02 286 89.6 328.5 128.1 364.3C169.2 402.4 222.8 432 288 432C353.2 432 406.8 402.4 447.9 364.3C486.4 328.5 512.1 286 526.6 256C512.1 225.1 486.4 183.5 447.9 147.7C406.8 109.6 353.2 80 288 80V80z"
      />
    </svg>
  );
}
